import * as React from "react";

function AvatarSvg(props) {
  return (
    <svg
      width={50}
      height={50}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.5} y={0.5} width={55} height={55} rx={27.5} stroke="#000" />
      <path
        d="M28.266 26.117a3.042 3.042 0 00-.55 0c-3.966-.134-7.116-3.384-7.116-7.384 0-4.083 3.3-7.4 7.4-7.4 4.083 0 7.4 3.317 7.4 7.4-.017 4-3.167 7.25-7.134 7.384zM19.933 32.267c-4.033 2.7-4.033 7.1 0 9.783 4.584 3.067 12.1 3.067 16.684 0 4.033-2.7 4.033-7.1 0-9.783-4.567-3.05-12.084-3.05-16.684 0z"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default AvatarSvg;
